const internacional = [
  {
    id: 1,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 25/26 - Uniforme 1",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2025",
      "2025 internacional",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/25-26-01/uni0.jpg",
      "/images/brasil/serie-a/internacional/25-26-01/uni1.jpg",
      "/images/brasil/serie-a/internacional/25-26-01/uni2.jpg",
      "/images/brasil/serie-a/internacional/25-26-01/uni3.jpg",
      "/images/brasil/serie-a/internacional/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 25/26 - Uniforme 2",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2025",
      "2025 internacional",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/25-26-02/uni0.jpg",
      "/images/brasil/serie-a/internacional/25-26-02/uni1.jpg",
      "/images/brasil/serie-a/internacional/25-26-02/uni2.jpg",
      "/images/brasil/serie-a/internacional/25-26-02/uni3.jpg",
      "/images/brasil/serie-a/internacional/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 25/26 - Uniforme 3",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2025",
      "2025 internacional",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/25-26-03/uni0.jpg",
      "/images/brasil/serie-a/internacional/25-26-03/uni1.jpg",
      "/images/brasil/serie-a/internacional/25-26-03/uni2.jpg",
      "/images/brasil/serie-a/internacional/25-26-03/uni3.jpg",
      "/images/brasil/serie-a/internacional/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 25/26 - Uniforme 1 (Feminino)",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2025",
      "2025 internacional",
      "2025",
      "feminino",
      "inter feminino",
      "internacional feminino",
      "feminino inter",
      "feminino internacional",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/25-26-01-f/uni0.jpg",
      "/images/brasil/serie-a/internacional/25-26-01-f/uni1.jpg",
      "/images/brasil/serie-a/internacional/25-26-01-f/uni2.jpg",
      "/images/brasil/serie-a/internacional/25-26-01-f/uni3.jpg",
      "/images/brasil/serie-a/internacional/25-26-01-f/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 24/25 - Uniforme 1 (Feminino)",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2024",
      "2024 internacional",
      "2024",
      "feminino",
      "inter feminino",
      "internacional feminino",
      "feminino inter",
      "feminino internacional",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/24-25-01-f/uni0.jpg",
      "/images/brasil/serie-a/internacional/24-25-01-f/uni1.jpg",
      "/images/brasil/serie-a/internacional/24-25-01-f/uni2.jpg",
      "/images/brasil/serie-a/internacional/24-25-01-f/uni3.jpg",
      "/images/brasil/serie-a/internacional/24-25-01-f/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 25/26 - Jaqueta (Vermelha/Branca)",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2025",
      "2025 internacional",
      "2025",
      "jaqueta internacional",
      "internacional jaqueta",
      "jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/24-25-00-jvb/uni0.jpg",
      "/images/brasil/serie-a/internacional/24-25-00-jvb/uni1.jpg",
      "/images/brasil/serie-a/internacional/24-25-00-jvb/uni2.jpg",
      "/images/brasil/serie-a/internacional/24-25-00-jvb/uni3.jpg",
    ],
  },
  {
    id: 7,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 24/25 - Uniforme 1",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2024",
      "2024 internacional",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/24-25-01/uni0.jpg",
      "/images/brasil/serie-a/internacional/24-25-01/uni1.jpg",
      "/images/brasil/serie-a/internacional/24-25-01/uni2.jpg",
      "/images/brasil/serie-a/internacional/24-25-01/uni3.jpg",
      "/images/brasil/serie-a/internacional/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 23/24 - Uniforme 1",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2023",
      "2023 internacional",
      "2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/23-24-01/uni0.jpg",
      "/images/brasil/serie-a/internacional/23-24-01/uni1.jpg",
      "/images/brasil/serie-a/internacional/23-24-01/uni2.jpg",
      "/images/brasil/serie-a/internacional/23-24-01/uni3.jpg",
      "/images/brasil/serie-a/internacional/23-24-01/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 23/24 - Uniforme 2",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2023",
      "2023 internacional",
      "2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/23-24-02/uni0.jpg",
      "/images/brasil/serie-a/internacional/23-24-02/uni1.jpg",
      "/images/brasil/serie-a/internacional/23-24-02/uni2.jpg",
      "/images/brasil/serie-a/internacional/23-24-02/uni3.jpg",
      "/images/brasil/serie-a/internacional/23-24-02/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 22/21 - Uniforme 1",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2022",
      "2022 internacional",
      "2022",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/22-23-01/uni0.jpg",
      "/images/brasil/serie-a/internacional/22-23-01/uni1.jpg",
      "/images/brasil/serie-a/internacional/22-23-01/uni2.jpg",
      "/images/brasil/serie-a/internacional/22-23-01/uni3.jpg",
      "/images/brasil/serie-a/internacional/22-23-01/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 22/23 - Jaqueta (Vermelha)",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2022",
      "2022 internacional",
      "2022",
      "jaqueta internacional",
      "internacional jaqueta",
      "jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/22-23-01-jv/uni0.jpg",
      "/images/brasil/serie-a/internacional/22-23-01-jv/uni1.jpg",
      "/images/brasil/serie-a/internacional/22-23-01-jv/uni2.png",
      "/images/brasil/serie-a/internacional/22-23-01-jv/uni3.png",
      "/images/brasil/serie-a/internacional/22-23-01-jv/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 21/22 - Uniforme 1",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2021",
      "2021 internacional",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/21-22-01/uni0.jpg",
      "/images/brasil/serie-a/internacional/21-22-01/uni1.jpg",
      "/images/brasil/serie-a/internacional/21-22-01/uni2.jpg",
      "/images/brasil/serie-a/internacional/21-22-01/uni3.jpg",
      "/images/brasil/serie-a/internacional/21-22-01/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 21/22 - Uniforme 2",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2021",
      "2021 internacional",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/21-22-02/uni0.jpg",
      "/images/brasil/serie-a/internacional/21-22-02/uni1.jpg",
      "/images/brasil/serie-a/internacional/21-22-02/uni2.jpg",
      "/images/brasil/serie-a/internacional/21-22-02/uni3.jpg",
      "/images/brasil/serie-a/internacional/21-22-02/uni4.jpg",
    ],
  },
  {
    id: 14,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 21/22 - Uniforme 3",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2021",
      "2021 internacional",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/21-22-03/uni0.jpg",
      "/images/brasil/serie-a/internacional/21-22-03/uni1.jpg",
      "/images/brasil/serie-a/internacional/21-22-03/uni2.jpg",
      "/images/brasil/serie-a/internacional/21-22-03/uni3.jpg",
      "/images/brasil/serie-a/internacional/21-22-03/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 21/22 - Uniforme Edição Especial",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2021",
      "2021 internacional",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/internacional/21-22-00-esb/uni0.jpg",
      "/images/brasil/serie-a/internacional/21-22-00-esb/uni1.jpg",
      "/images/brasil/serie-a/internacional/21-22-00-esb/uni2.jpg",
      "/images/brasil/serie-a/internacional/21-22-00-esb/uni3.jpg",
      "/images/brasil/serie-a/internacional/21-22-00-esb/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 21/22 - Uniforme (Feminino)",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2021",
      "2021 internacional",
      "2021",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/21-22-00-esf/uni0.jpg",
      "/images/brasil/serie-a/internacional/21-22-00-esf/uni1.jpg",
      "/images/brasil/serie-a/internacional/21-22-00-esf/uni2.jpg",
      "/images/brasil/serie-a/internacional/21-22-00-esf/uni3.jpg",
      "/images/brasil/serie-a/internacional/21-22-00-esf/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 21/22 - Uniforme 1 (Feminino)",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2021",
      "2021 internacional",
      "2021",
      "feminino",
      "inter feminino",
      "internacional feminino",
      "feminino inter",
      "feminino internacional",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/21-22-01-f/uni0.jpg",
      "/images/brasil/serie-a/internacional/21-22-01-f/uni1.jpg",
      "/images/brasil/serie-a/internacional/21-22-01-f/uni2.jpg",
      "/images/brasil/serie-a/internacional/21-22-01-f/uni3.jpg",
      "/images/brasil/serie-a/internacional/21-22-01-f/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 21/22 - Uniforme de Pré Jogo (Vermelho)",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2021",
      "2021 internacional",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/21-22-05-pjv/uni0.jpg",
      "/images/brasil/serie-a/internacional/21-22-05-pjv/uni1.jpg",
      "/images/brasil/serie-a/internacional/21-22-05-pjv/uni2.jpg",
      "/images/brasil/serie-a/internacional/21-22-05-pjv/uni3.jpg",
      "/images/brasil/serie-a/internacional/21-22-05-pjv/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 21/22 - Uniforme de Pré Jogo (Amarela)",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2021",
      "2021 internacional",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/21-22-05-ta/uni0.jpg",
      "/images/brasil/serie-a/internacional/21-22-05-ta/uni1.jpg",
      "/images/brasil/serie-a/internacional/21-22-05-ta/uni2.jpg",
      "/images/brasil/serie-a/internacional/21-22-05-ta/uni3.jpg",
      "/images/brasil/serie-a/internacional/21-22-05-ta/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 21/22 - Uniforme de Treino (Preta)",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2021",
      "2021 internacional",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/21-22-05-tp/uni0.jpg",
      "/images/brasil/serie-a/internacional/21-22-05-tp/uni1.jpg",
      "/images/brasil/serie-a/internacional/21-22-05-tp/uni2.jpg",
      "/images/brasil/serie-a/internacional/21-22-05-tp/uni3.jpg",
      "/images/brasil/serie-a/internacional/21-22-05-tp/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 20/21 - Uniforme Edição Especial",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2020",
      "2020 internacional",
      "2020",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/internacional/20-21-00-esr/uni0.jpg",
      "/images/brasil/serie-a/internacional/20-21-00-esr/uni1.jpg",
      "/images/brasil/serie-a/internacional/20-21-00-esr/uni2.jpg",
      "/images/brasil/serie-a/internacional/20-21-00-esr/uni3.jpg",
      "/images/brasil/serie-a/internacional/20-21-00-esr/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 20/21 - Uniforme 1",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2020",
      "2020 internacional",
      "2020",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/20-21-01/uni0.jpg",
      "/images/brasil/serie-a/internacional/20-21-01/uni1.jpg",
      "/images/brasil/serie-a/internacional/20-21-01/uni2.jpg",
      "/images/brasil/serie-a/internacional/20-21-01/uni3.jpg",
      "/images/brasil/serie-a/internacional/20-21-01/uni4.jpg",
    ],
  },
  {
    id: 23,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 20/21 - Uniforme 2",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2020",
      "2020 internacional",
      "2020",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/20-21-02/uni0.jpg",
      "/images/brasil/serie-a/internacional/20-21-02/uni1.jpg",
      "/images/brasil/serie-a/internacional/20-21-02/uni2.jpg",
      "/images/brasil/serie-a/internacional/20-21-02/uni3.jpg",
      "/images/brasil/serie-a/internacional/20-21-02/uni4.jpg",
    ],
  },
  {
    id: 24,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 20/21 - Uniforme 3",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional 2020",
      "2020 internacional",
      "2020",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/internacional/20-21-03/uni0.jpg",
      "/images/brasil/serie-a/internacional/20-21-03/uni1.jpg",
      "/images/brasil/serie-a/internacional/20-21-03/uni2.jpg",
      "/images/brasil/serie-a/internacional/20-21-03/uni3.jpg",
      "/images/brasil/serie-a/internacional/20-21-03/uni4.jpg",
    ],
  },
  {
    id: 25,
    pais: "brasil",
    liga: "serie-a",
    time: "internacional",
    nome: "Internacional 97/98 - Uniforme 1",
    aliases: [
      "internacional",
      "colorado",
      "inter",
      "internacional retro",
      "retro internacional",
      "retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/internacional/97-98-01-rt/uni0.jpg",
      "/images/brasil/serie-a/internacional/97-98-01-rt/uni1.jpg",
      "/images/brasil/serie-a/internacional/97-98-01-rt/uni2.jpg",
      "/images/brasil/serie-a/internacional/97-98-01-rt/uni3.jpg",
      "/images/brasil/serie-a/internacional/97-98-01-rt/uni4.jpg",
    ],
  },
];

export default internacional;
